import React, { Component } from "react";
import { Row, Col, Card, Button, Input, Select, Icon } from "antd";
import F from "../../Functions";
import axios from "axios";
import { Translate } from "react-translated";
import AddressField from "../../components/address-field";

class AgencyManagerProfile extends Component {
  state = {
    agencies: [],
  };
  componentDidMount = () => {
    axios.get(`/api/am_agencies_assoc/${this.props.user.id}`).then((res) => {
      F.log("Data = > ", res.data);
      this.setState({
        agencies: res.data,
      });
    });
  };

  showAgencies = () => {
    if (this.state.agencies && this.state.agencies.length > 0) {
      return this.state.agencies.map((agency) => <div key={agency.id}>{agency.name}</div>);
    } else {
      return <div>No Agencies Found</div>;
    }
  };


  render() {
    const { loading, user, updateField, update } = this.props;
    F.log("User = > ", user);
    return (
      <div>
        <Card
          type="inner"
          // title={<Translate text={`Personal Information`} />}
          title={<React.Fragment><Icon style={{ color: "#1890ff", marginRight: "5px" }} type="profile" /> <Translate text={` Personal Information`} /></React.Fragment>}

          loading={loading}
        >
          <div>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`First Name`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={user.first_name}
                    onChange={(e) => updateField("first_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Last Name`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={user.last_name}
                    onChange={(e) => updateField("last_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
            </Row>
            {/*<Row gutter={16}>
               <Col md={12} span={24}>
                                <div className="inputField">
                                    <label><Translate text={`Email`} />:</label>
                                    <Input value={user.email} onChange={(e) => updateField('email', e.target.value)} />
                                </div>
                            </Col> 
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Company Name`} />:
                  </label>
                  <Input
                    value={user.company_name}
                    onChange={(e) =>
                      updateField("company_name", e.target.value)
                    }
                  />
                </div>
              </Col>
            </Row>*/}
            <Row gutter={16}>
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Phone`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={F.phone_format(user.phone)}
                    onChange={(e) => {
                      if (e.target.value.trim().length <= 14) {
                        const updateNumber = F.phone_format(e.target.value);
                        updateField("phone", updateNumber);
                      }
                    }}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Mobile`} />
                  </label>
                  <Input
                    value={F.phone_format(user.mobile_number)}
                    onChange={(e) => {
                      if (e.target.value.trim().length <= 14) {
                        const updateNumber = F.phone_format(e.target.value);
                        updateField("mobile_number", updateNumber);
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Address`} />
                  </label>
                  <AddressField
                    value={user.address}
                    onChange={(val) => updateField("address", val)}
                    setCity={(val) => updateField("city", val)}
                    setState={(val) => updateField("state", val)}
                    setZipCode={(val) => updateField("zipcode", val)}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`City`} />
                  </label>
                  <Input
                    value={user.city}
                    onChange={(e) => updateField("city", e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`State`} />
                  </label>
                  <Input
                    value={user.state}
                    onChange={(e) => updateField("state", e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Zipcode`} />
                  </label>
                  <Input
                    value={user.zipcode}
                    onChange={(e) => updateField("zipcode", e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <h2>
              <Translate text={`Update Password`} />
            </h2>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <Button onClick={() => this.props.requestPassword()}
                    className="borderRadius-28"
                  >
                    <Translate text={`Request a new Password`} />
                  </Button>
                </div>
              </Col>
            </Row>

            <h2>
              <Translate text={`Agencies Associated`} />
            </h2>
            {this.state.agencies ? (
              <ul>
                <span className="custom_hk">
                  {this.state.agencies.map((agency) => {
                    // eslint-disable-next-line react/jsx-key
                    return <li>{agency.agency_name}</li>;
                  })}
                </span>
              </ul>
            ) : (
              <div>No Agencies Found</div>
            )}
          </div>
          <div className="right-align">
            <Button type="primary" onClick={update.bind(this)}
              className="bg-164897 borderRadius-28"
            >
              <Translate text={`Edit User`} />
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export default AgencyManagerProfile;



// WEBPACK FOOTER //
// ./src/scenes/Profile/agency_manager.js